export default __webpack_public_path__ + "static/media/email-profile.fe12c374.jpg";